const EmptyParams = {};
const Params = () => ({});
/**
 * Single source of truth for all overlay routes.
 * NOTICE: Order matters: it defines the deserialization priority (stack bottom → top).
 */
const _ROUTES = {
    cart: EmptyParams,
    search: Params(),
    product: Params(),
    added: EmptyParams,
    "free-delivery": EmptyParams,
    "deposit-info": EmptyParams,
    "service-fee": EmptyParams,
    "delivery-address": EmptyParams,
    "restaurant-info": EmptyParams,
    "menu-cross-selling": EmptyParams,
    "cart-cross-selling": EmptyParams,
    "menu-time": EmptyParams,
    "creator-time": EmptyParams,
    "cart-time": EmptyParams,
    "checkout-time": EmptyParams,
    tip: EmptyParams,
    stamps: EmptyParams,
    "blik-level0": EmptyParams,
    // Generic Bootstrap modals that run via data-bs-toggle="modal" params
    modal: Params(),
};
/**
 * All URL param keys managed by the overlay system.
 */
export const OVERLAY_ROUTE_NAMES = new Set(Object.keys(_ROUTES));
/**
 * Routes that can survive a page refresh (cold hydration from URL).
 */
export const HYDRATABLE_ROUTES = new Set(["product", "cart", "search", "modal"]);
